import * as React from 'react';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { VariantLifeCycle } from '@process-advisor/process-miner/modals/lifecycle/variantLifecycle'
import {
    StyledWrapper,
    StyledContent,
    StyledModal,
    StyledHeader,
    StyledIcon,
    StyledFooter,
    StyledTitle,
} from '@process-advisor/process-miner/components/modal/modal.styles'
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { Event } from '@process-advisor/process-miner/api/events';
import styled from 'styled-components';

const Analytic = styled.div`
    width: 900px;
    height: 650px;
    border: hidden;
    canvas {
        outline: none;
    };
`;

type Props = {
    props: {
        param: string,
    },
}

export type Data = []

export const VariantLifecycleModal: React.FC = () => {
    const [data, setData] = React.useState<Data[]>([]);
    const [props, setProps] = React.useState<{  param: string}>({ param: ''});
    const [open, setOpen] = React.useState(false);
    const [title, setTitle] = React.useState('');
    const [showCloseIcon, setShowCloseIcon] = React.useState(true);

    function onClose() {
        setOpen(false)
    }
    useApiListener(
        Event.openVariantLifecycleModal,
        ({ props }: Props) => {
            setOpen(true);
            setProps(props);
            //setTitle(props.object_type + ' ' + apiProvider.getEntityUpper() + ' History'  )
            setTitle('Variant Lifecycle')
        }
    );

    return (
        <StyledWrapper open={open} onClose={onClose}>
            <StyledModal >
                <StyledHeader>
                    <StyledTitle>{title}</StyledTitle>
                    {showCloseIcon ? <StyledIcon onClick={onClose} /> : <div />}
                </StyledHeader>
                <StyledContent>
                    <Analytic>
                        <VariantLifeCycle/>
                    </Analytic> 
                </StyledContent>
                <StyledFooter>
                    <Button label='Close' onClick={onClose} disabled={false} />
                </StyledFooter>
            </StyledModal>
        </StyledWrapper>
    );
};

